module.exports = __webpack_public_path__ + "assets/done.0ebb267c434bde0aa47fc0c4353d4395.png";